import { useHubRole } from "@/hooks/use-hub-role";
import { useViewOnlyMode } from "@/hooks/use-view-only-mode";

/**
 * Shared client-side guard for Hub template controls.
 *
 * This is deliberately only a UI affordance: every mutation remains
 * authorized by the API. Runtime/progress interactions are not affected.
 */
export function useHubWriteAccess(hubId?: string) {
  const role = useHubRole(hubId);
  const isViewOnly = useViewOnlyMode();
  const normalizedRole = String(role || "").toLowerCase();
  const isOwner = normalizedRole === "owner";
  const canEditRole = isOwner || normalizedRole === "manager" || normalizedRole === "collaborator";

  return {
    role,
    isOwner,
    canEditRole,
    isViewOnly,
    canWrite: !isViewOnly && canEditRole,
  };
}